import React from 'react';
import { Box } from '@components/Box';
import { BeAmazingMobile } from './BeAmazingMobile';
import { BeAmazingDesktop } from './BeAmazingDesktop';
import { styled } from '@components/styledComponents';
import { themeMediaQuery } from '@utils/styledTheme.util';

const DisplayAboveMobile = styled(Box)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const BeAmazing: React.FC = () => {
  return (
    <>
      <DisplayOnMobile>
        <BeAmazingMobile></BeAmazingMobile>
      </DisplayOnMobile>
      <DisplayAboveMobile>
        <BeAmazingDesktop></BeAmazingDesktop>
      </DisplayAboveMobile>
    </>
  );
};
